import soft_skills from "../../data/projects/enums/soft_skills";
import BaseFilter from "./BaseFilter";

interface SoftSkillsFilterProps {
  pickedOptions: string[];
  setPickedOptions: (newState: any) => void;
  show: boolean;
  setShow: (key: string) => void;
  displayColumn?: boolean;
  title?: string;
  filterKey?: string;
  isAdd?: boolean;
}

export default function SoftSkillsFilter({
  pickedOptions,
  setPickedOptions,
  show,
  setShow,
  displayColumn = true,
  title = "Soft Skills",
  filterKey = "softSkills",
  maxDisplayOptions,
  isAdd,
}: any) {
  return (
    <BaseFilter
      pickedOptions={pickedOptions}
      setPickedOptions={setPickedOptions}
      show={show}
      setShow={setShow}
      displayColumn={displayColumn}
      title={title}
      filterKey={filterKey}
      originalOptions={soft_skills}
      filterType="softSkills"
      showProposeButton={true}
      maxDisplayOptions={maxDisplayOptions}
      isAdd={isAdd}
    />
  );
}
